import { generateUUID } from "./uuid";

let sessionUUID = null;

export const getOrCreateSessionUUID = () => {
  if (!sessionUUID) {
    sessionUUID = generateUUID();
  }
  return sessionUUID;
};

export const clearSessionUUID = () => {
  sessionUUID = null;
};